var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4073 6.66669C21.2973 6.67169 23.524 6.69335 25.8906 6.78835L26.7306 6.82502C29.1123 6.93669 31.4923 7.13002 32.674 7.45835C34.249 7.90169 35.4856 9.19169 35.904 10.8284C36.5706 13.4284 36.654 18.4984 36.664 19.7267L36.6656 19.98V20.27C36.654 21.4984 36.5706 26.57 35.904 29.1684C35.4806 30.81 34.2423 32.1017 32.674 32.5384C31.4923 32.8667 29.1123 33.06 26.7306 33.1717L25.8906 33.21C23.524 33.3034 21.2973 33.3267 20.4073 33.33L20.0156 33.3317H19.5906C17.7073 33.32 9.83065 33.235 7.32398 32.5384C5.75065 32.095 4.51232 30.805 4.09398 29.1684C3.42732 26.5684 3.34398 21.4984 3.33398 20.27V19.7267C3.34398 18.4984 3.42732 13.4267 4.09398 10.8284C4.51732 9.18669 5.75565 7.89502 7.32565 7.46002C9.83065 6.76169 17.709 6.67669 19.5923 6.66669H20.4073ZM16.6656 14.1667V25.8334L26.6656 20L16.6656 14.1667Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon_youtube.ce22cc300ac43a0e542fe75fd51bc06a.svg";
export { ForwardRef as ReactComponent };